var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromises(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.345,
    height: 32.939,
    viewBox: "0 0 23.345 32.939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8099",
    "data-name": "Grupo 8099",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bookmark",
    d: "M2,4.117A4.009,4.009,0,0,1,5.891,0H21.454a4.009,4.009,0,0,1,3.891,4.117V31.91a1.039,1.039,0,0,1-.514.907.927.927,0,0,1-1-.051l-10.161-5.8-10.161,5.8a.927.927,0,0,1-1,.051A1.039,1.039,0,0,1,2,31.91ZM5.891,2.059A2,2,0,0,0,3.945,4.117v25.87l9.188-5.11a.928.928,0,0,1,1.078,0l9.188,5.11V4.117a2,2,0,0,0-1.945-2.059Z",
    transform: "translate(-2 0)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "%",
    transform: "translate(4.022 18.709)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 0.5,
    fontSize: 17,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "-0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "%")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromises);
export default __webpack_public_path__ + "static/media/promises.d72d39cb4a7f0c19f014d24393ad9efb.svg";
export { ForwardRef as ReactComponent };